export default "__VITE_ASSET__f550931f__"